import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  AuthenticatorValidationDataDto,
  AuthenticatorValidationResultDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_USERS } from "../../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_VALIDATE_AUTHENTICATOR = "VALIDATE_AUTHENTICATOR";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const validateAuthenticator = async (
  param: AuthenticatorValidationDataDto,
): Promise<AuthenticatorValidationResultDto> => {
  const response = await usersApi.usersControllerValidateAuthenticatorData(param);

  return response.data;
};

export const useValidateAuthenticator = (
  user: UserProfileDto | null,
): {
  validateAuthenticator: (param: AuthenticatorValidationDataDto) => void;
  validateAuthenticatorEnabled: boolean;
  validateAuthenticatorError: Error | null;
  isSuccessValidateAuthenticator: boolean;
  isPendingValidateAuthenticator: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_VALIDATE_AUTHENTICATOR],
    mutationFn: enabled ? validateAuthenticator : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    validateAuthenticator: mutate,
    validateAuthenticatorEnabled: enabled,
    validateAuthenticatorError: error,
    isSuccessValidateAuthenticator: isSuccess,
    isPendingValidateAuthenticator: isPending,
  };
};
